import { Button } from "@mui/material";

import type { PollButtonProps } from "../../../utils/convert-to-mjml/poll-buttons/types";
import type { FC } from "react";

export const VerticalPollOptions: FC<Omit<PollButtonProps, "align">> = ({
  buttonType,
  options,
  buttonWidth,
}) => (
  <>
    {options.map((option) => (
      // oxlint-disable-next-line ce/require-button-id
      <Button
        className={buttonType}
        key={option.text}
        sx={{ cursor: "default", width: buttonWidth }}
      >
        {option.text}
      </Button>
    ))}
  </>
);
